export function saveCart(state){
  return {
    type: 'SAVE_CART',
    payload: state
  }
}